import React, { useMemo } from 'react';
import { animated, useSpring } from 'react-spring';
import { useInView } from 'react-intersection-observer';

function TransitionInView({ children, direction, threshold = 0.1, triggerOnce = true, delay = 100 }) {
   const [ref, inView] = useInView({
      threshold: threshold, // How much of the item needs to be visible to trigger
      triggerOnce: triggerOnce, // Only trigger the animation once
   });

   // Determine the initial transform based on the direction
   const initialTransform = useMemo(() => {
      switch (direction) {
         case 'fromBottom':
            return 'translate3d(0, 4rem, 0)';
         case 'fromTop':
            return 'translate3d(0, -4rem, 0)';
         case 'fromLeft':
            return 'translate3d(-4rem, 0, 0)';
         case 'fromRight':
            return 'translate3d(4rem, 0, 0)';
         default:
            return 'translate3d(0, 4rem, 0)'; // Default to fromBottom
      }
   }, [direction]);

   const springConfig = { mass: 3, tension: 200, friction: 70 };

   const props = useSpring({
      config: springConfig,
      delay: inView ? delay : 0, // Apply delay only when animating in
      opacity: inView ? 1 : 0,
      transform: inView ? 'translate3d(0, 0, 0)' : initialTransform,
   });

   return (
      <animated.div ref={ref} style={props}>
         {children}
      </animated.div>
   );
}

export default TransitionInView;
